import { Entry } from '../Entry'

export function Entry20250610() {
  return (
    <Entry title="2025 Jun 10 - v3.10.12">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/17884/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
